// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { getPublicLink } from '../publishedBoardUtils';
import { getIsEmbedGenerated } from '../../../../../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { updateElement } from '../../../../../../../element/actions/elementActions';

// Components
import ToggleInput from '../../../../../../../components/form/fields/ToggleInput';
import TooltipSource from '../../../../../../../components/tooltips/TooltipSource';
import ToggleContents from '../../../../../../../components/form/fields/ToggleContents';
import StaticURLField from '../../../../../../../components/form/fields/StaticURLField';
import SettingsRow from '../../../../../../../user/account/accountModal/components/SettingsRow';

// Constants
import { TooltipPositions } from '../../../../../../../components/tooltips/tooltipConstants';
import { TIMES } from '../../../../../../../../common/utils/timeUtil';
import { APP_QUERY_PARAMS } from '../../../../../../../../common/utils/urlConstants';

// Styles
import './PublishBoardEmbedToggle.scss';

const getIframeText = (iframeUrl) => `<iframe src="${iframeUrl}" width="800" height="500" frameborder="0"></iframe>`;

const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateBoardPublishEmbedToggle: ({ id, embedGenerated }) =>
        dispatch(
            updateElement({
                id,
                changes: {
                    embedGenerated,
                },
                sync: true,
            }),
        ),
});

const PublishBoardEmbedToggle = (props) => {
    const {
        isPublished,
        passwordEnabled,
        hasLegacyPublicPermissions,
        canModifySettings,
        currentBoardId,
        currentBoard,
        currentBoardPublishedPermissionId,
        dispatchUpdateBoardPublishEmbedToggle,
    } = props;

    const generateEmbed = getIsEmbedGenerated(currentBoard);

    const onToggleGenerateEmbed = (event) => {
        dispatchUpdateBoardPublishEmbedToggle({
            id: currentBoardId,
            embedGenerated: event.target.checked,
        });
    };

    const iframeUrl = hasLegacyPublicPermissions
        ? getPublicLink(currentBoardId)
        : `${getPublicLink(currentBoardId)}?${APP_QUERY_PARAMS.PERMISSION}=${currentBoardPublishedPermissionId}`;

    const iframeHtml = getIframeText(iframeUrl);

    return (
        <div className="PublishBoardEmbedToggle">
            <TooltipSource
                enabled={passwordEnabled && isPublished}
                className="embed-disabled-tooltip"
                triggerOnClick
                position={TooltipPositions.RIGHT}
                duration={TIMES.SECOND * 3}
                tooltipText="Can't embed password protected boards"
            >
                <SettingsRow
                    disabled={!isPublished || passwordEnabled}
                    label="Generate HTML embed code"
                    className="secondary-row embed-settings-row"
                >
                    <ToggleInput
                        disabled={!canModifySettings}
                        active={generateEmbed && !passwordEnabled}
                        onChange={onToggleGenerateEmbed}
                    />
                </SettingsRow>
            </TooltipSource>
            <ToggleContents active={generateEmbed && !passwordEnabled} disabled={!canModifySettings}>
                <div className="setting-contents">
                    <StaticURLField url={iframeHtml} buttonText="Copy code" />
                </div>
            </ToggleContents>
        </div>
    );
};

PublishBoardEmbedToggle.propTypes = {
    isPublished: PropTypes.bool,
    passwordEnabled: PropTypes.bool,
    hasLegacyPublicPermissions: PropTypes.bool,
    canModifySettings: PropTypes.bool,

    currentBoard: PropTypes.object,
    currentBoardId: PropTypes.string,
    currentBoardPublishedPermissionId: PropTypes.string,

    dispatchUpdateBoardPublishEmbedToggle: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(PublishBoardEmbedToggle);
